<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col 
          md="6" 
          class="text-center">
          <div class="clearfix">
            <h1 class="display-3">Please wait</h1>
            <div class="clearfix" />
            <div style="margin: 0 auto width: 10px">
              <div class="loader-dark-blue medium mb-5 mt-5" />
            </div>
            <h4>You'll be redirected shortly.</h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { auth, server } from '@/services/';
import nav from '@/_nav';

export default {
  name: 'Redirect',
  created() {
    let hash = this.$route.query.hash;
    auth.setToken(hash);
    server.get('/sso/getLoginUserInfo').then(resp => {
      const user = resp.data.msgContent.data.pop();
      const { USER_SERVICE_CODE, ...rest } = user;
      auth.setUser(rest);
      const service = USER_SERVICE_CODE.find(
        o => o.SERVICE_CODE === process.env.VUE_APP_SERVICE_CODE
      );
      auth.setServiceModule(service);
      const roles = service.USER_MODULE.map(o => o.USER_ROLE_NAME.toLowerCase())
      auth.setRoles(roles)
      if (roles.includes('tribecar')) {
        this.$router.push({name: 'TribecarReservations'})
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    });
  }
};
</script>
